// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:979px){#modalantechhealthtrackui.modal.fade.in{top:0;left:0}}@media (min-width:992px){.modal-xl{max-width:990px!important}}@media (min-width:1200px){.modal-xl{max-width:1140px!important}}@media (min-width:1300px){.modal-xl{max-width:1250px!important}}#modalantechhealthtrackui .modal-body{background-color:#fff;padding:0}#modalantechhealthtrackui{overflow-x:auto}#pims-immersion-iframe-container{position:relative}", ""]);
// Exports
module.exports = exports;
